import { MessageSquare, Eraser, PanelLeftClose } from 'lucide-react';
import { useChatStore } from '@/stores/chatStore';
import { useMapStore } from '@/stores/mapStore';
import { useUIStore } from '@/stores/uiStore';
import { useAuthStore } from '@/stores/authStore';
import { clearContext } from '@/api/ares';
import { useToast } from '@/hooks/useToast';

export default function ChatHeader() {
  const clearMessages = useChatStore((s) => s.clearMessages);
  const clearFeatures = useMapStore((s) => s.clearFeatures);
  const setRouteData = useMapStore((s) => s.setRouteData);
  const setLivePosition = useMapStore((s) => s.setLivePosition);
  const clearRouteLines = useMapStore((s) => s.clearRouteLines);
  const toggleSidebar = useUIStore((s) => s.toggleSidebar);
  const setRoutePanelOpen = useUIStore((s) => s.setRoutePanelOpen);
  const setFleetPanelOpen = useUIStore((s) => s.setFleetPanelOpen);
  const setChartModalOpen = useUIStore((s) => s.setChartModalOpen);
  const setCurrentExportId = useUIStore((s) => s.setCurrentExportId);
  const getSessionId = useAuthStore((s) => s.getSessionId);
  const resetSessionId = useAuthStore((s) => s.resetSessionId);
  const { toast } = useToast();

  const handleClearChat = async () => {
    const sessionId = getSessionId();
    try {
      clearMessages();
      clearFeatures();
      clearRouteLines();
      setRouteData(null);
      setLivePosition(null);
      setRoutePanelOpen(false);
      setFleetPanelOpen(false, []);
      setChartModalOpen(false);
      setCurrentExportId(null);
      await clearContext(sessionId);
      resetSessionId();
      toast('Chat limpiado', 'success');
    } catch {
      toast('Error al limpiar chat', 'error');
    }
  };

  return (
    <div className="px-4 py-2.5 border-b border-border-subtle flex items-center justify-between bg-bg-secondary">
      <div className="flex items-center gap-2 text-sm font-semibold uppercase text-text-muted tracking-wider">
        <MessageSquare className="text-accent-blue" size={14} />
        Agente IA
      </div>
      <div className="flex gap-1.5">
        <button
          onClick={handleClearChat}
          className="w-8 h-8 bg-transparent border border-border-subtle rounded-md text-text-muted hover:bg-bg-elevated hover:text-accent-blue hover:border-accent-blue flex items-center justify-center transition-all"
          title="Limpiar chat"
        >
          <Eraser size={14} />
        </button>
        <button
          onClick={toggleSidebar}
          className="w-8 h-8 bg-transparent border border-border-subtle rounded-md text-text-muted hover:bg-bg-elevated hover:text-accent-blue hover:border-accent-blue flex items-center justify-center transition-all"
          title="Ocultar chat"
        >
          <PanelLeftClose size={14} />
        </button>
      </div>
    </div>
  );
}
